import * as React from "react";
import { Flex, Grid, Stack, Divider, Text, useMantineTheme, Badge } from "@mantine/core";
import RGL, { WidthProvider } from "react-grid-layout";

import { UseCaseBasicType, UseCaseRunDetails } from "@supportinitiative/common";
import Loading from "../../ui/Loading";
import Actions from "./Actions";
import MasterDataset from "./MasterDataset";
import Stats from "./Stats";
import { getDahsboards } from "../Dashboard/Dashboards";
import Dashboard from "../Dashboard/Dashboard";
import SummaryStats from "./SummaryStats";

const layout = [
  {
    w: 3,
    h: 29,
    x: 0,
    y: 4,
    i: "actions",
    moved: false,
    static: false,
  },
  {
    w: 5,
    h: 4,
    x: 0,
    y: 0,
    i: "master",
    moved: false,
    static: false,
  },
  {
    w: 7,
    h: 6,
    x: 5,
    y: 0,
    i: "summaryStats",
    moved: false,
    static: false,
  },
  {
    w: 9,
    h: 6,
    x: 3,
    y: 6,
    i: "iwni5",
    moved: false,
    static: false,
  },
  {
    w: 9,
    h: 7,
    x: 3,
    y: 12,
    i: "t7y03",
    moved: false,
    static: false,
  },
  {
    w: 9,
    h: 10,
    x: 3,
    y: 19,
    i: "stats",
    moved: false,
    static: false,
  },
];

const ReactGridLayout = WidthProvider(RGL);

export function UseCaseGrid({
  useCase,
  run,
  access,
  reOrg,
}: {
  useCase: UseCaseBasicType;
  run: UseCaseRunDetails;
  access: string;
  reOrg: boolean;
}) {
  // layout is an array of objects, see the demo for more complete usage
  const theme = useMantineTheme();
  if (run) {
    return (
      <ReactGridLayout
        className="layout"
        layout={layout}
        cols={12}
        rowHeight={30}
        width={1200}
        onLayoutChange={(layout) => {
          console.log("layout", layout);
        }}
        isDraggable={reOrg}
        isResizable={reOrg}
      >
        <div key="actions">
          <Actions actions={run?.actions} />
        </div>

        {useCase.definition.masterDataset.type === "DATASET" ? (
          <div key="master">
            <MasterDataset useCase={useCase} masterDataset={run?.masterDataset} />
          </div>
        ) : (
          <></>
        )}

        <div key="summaryStats">
          <SummaryStats summaryStats={run.summaryStats} />
        </div>

        {getDahsboards(
          useCase.entityId,
          useCase.id.toString(),
          run.details.runId,
          useCase.definition.preferences.run === "CONTINUOUS" ? run.details.completedRunSeq : run.details.runSeq,
          access,
          useCase.definition.dashboards,
        )}

        <div key="stats">
          <Stats useCase={useCase} run={run} access={access} stats={run?.stats} />
        </div>
      </ReactGridLayout>
    );
  } else {
    return (
      <Grid align="center" gutter={"xs"} mb="xs" mt="lg">
        <Grid.Col span={4}>
          <Loading />
        </Grid.Col>
      </Grid>
    );
  }
}
